import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { dividerClass } from './styles';

var Divider =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Divider, _PureComponent);

  var _super = _createSuper2(Divider);

  function Divider() {
    _classCallCheck(this, Divider);

    return _super.apply(this, arguments);
  }

  _createClass(Divider, [{
    key: "showText",
    value: function showText() {
      var _this$props = this.props,
          children = _this$props.children,
          mode = _this$props.mode;
      return children && mode === 'horizontal';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          children = _this$props2.children,
          mode = _this$props2.mode,
          orientation = _this$props2.orientation,
          restProps = _objectWithoutProperties(_this$props2, ["className", "children", "mode", "orientation"]);

      var mc = classnames(dividerClass('_', mode, children && 'with-text', orientation && "with-text-".concat(orientation)), className);
      return (
        /*#__PURE__*/
        React.createElement("div", Object.assign({}, restProps, {
          className: mc
        }), this.showText() &&
        /*#__PURE__*/
        React.createElement("span", {
          className: dividerClass('inner-text')
        }, children))
      );
    }
  }]);

  return Divider;
}(PureComponent);

Divider.defaultProps = {
  mode: 'horizontal'
};
export default Divider;